import styled, { css } from "styled-components";

import base from "@/themes/base/base";
import { desktopLargeMedia } from "@/themes/breakpoints";

export const SessionItemContainer = styled.a`
    display: flex;
    align-items: center;
    padding: 1.125rem 1.5rem;
    border-radius: 0.5rem;
    background: ${base.colors.neutral.grey[800]};
    cursor: pointer;
    transition: all 300ms;
    text-decoration: none;
    user-select: none;
    width: 100%;
    margin-bottom: 1rem;

    ${desktopLargeMedia} {
        width: 83%;
        align-self: flex-end;
        margin-bottom: 1.5rem;
    }

    & .chevron-container svg path {
        transition: all 300ms;
    }

    &:hover {
        background: ${base.colors.neutral.grey[600]};

        .chevron-container svg path {
            fill: #f2f2f2;
        }
    }
`;

export const SessionIconContainer = styled.div`
    display: flex;
    align-items: center;
    align-self: flex-start;
`;

export const StyledImg = styled.img`
    width: 4rem;
`;

export const SessionInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);
    width: 100%;
    height: 100%;
    margin-left: 1rem;
`;

export const SessionTitle = styled.div`
    ${base.typography.extraLargeMedium};

    display: flex;
    align-items: center;
    gap: var(--spacing-8);
    color: ${base.colors.neutral.grey[50]};
`;

export const GlobalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
`;

export const CrewsAndIconWrapper = styled.div`
    display: flex;
    gap: var(--spacing-8);
`;

export const UnitsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
`;

export const CrewsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
`;

export const IndividualCrewWrapper = styled.div`
    display: flex;
    gap: var(--spacing-8);
`;

export const UserLabel = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacing-4);
    color: ${base.colors.neutral.grey[300]};
`;

export const RemainingCrewsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
`;

export const ViewMoreWrapper = styled.div`
    display: flex;
    align-items: center;
    align-self: flex-end;
    gap: var(--spacing-4);
    color: grey;
    padding: 0 var(--spacing-4);
    cursor: pointer;

    path {
        stroke: ${base.colors.neutral.grey[300]};
    }

    &:hover {
        color: ${base.colors.neutral.grey[50]};

        path {
            stroke: ${base.colors.neutral.grey[50]};
        }
    }
`;

export const DateTimeAndDurationWrapper = styled.div`
    display: flex;
    gap: var(--spacing-8);
    align-items: center;
`;

export const DateAndTimeWrapper = styled.div`
    display: flex;
    gap: var(--spacing-8);
`;

const sharedDateTimeAndDurationStyles = css`
    gap: 0.5rem;
    display: flex;
    align-items: center;
    color: ${base.colors.neutral.grey[300]};
`;

export const DurationDiv = styled.div`
    ${sharedDateTimeAndDurationStyles};
`;

const sharedStyles = css`
    gap: var(--spacing-4);
    display: flex;
    align-items: center;
    color: ${base.colors.neutral.grey[300]};
`;

export const DateDiv = styled.div`
    ${sharedStyles};
`;

export const TimeDiv = styled.div`
    ${sharedStyles};
`;

export const DetailItemTextSpan = styled.span`
    color: ${base.colors.neutral.grey[300]};
`;

export const CardArrowContainer = styled.div`
    margin-left: 1.5rem;
    width: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;
